export const rocket = () => (
  <path
    d="M7.12 17.042s-1.36-6.8 3.401-11.561c4.76-4.76 11.561-3.4 11.561-3.4s1.36 6.8-3.4 11.56c-4.76 4.761-11.561 3.401-11.561 3.401zm0 0l-4.76-.68L1 15.002l3.4-3.4 2.554 2.553m.167 2.887l.68 4.76 1.36 1.361 3.4-3.4-2.554-2.555m6.955-5.926a2.885 2.885 0 11-4.08-4.08 2.885 2.885 0 014.08 4.08z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
